import * as React from "react";
import BlackDecemberPoints from "./BlackDecemberPoints";
import ProgressDaysRemaining from "./ProgressDaysRemaining";
import LevelStatus from "./LevelStatus";
import { Divider } from "antd";
import BlackDecemberRules from "./BlackDecemberRules";
import { useContext, useEffect, useState } from "react";
import { ServiceContext } from "src/services/provider/Service.provider";
import ITradesPoints from "src/services/interfaces/ITradesPoints";

import "./black-december.scss";

export default function BlackDecemberDashboard(props) {
  const { tradeService } = useContext(ServiceContext);
  const [tradesPoints, setTradesPoints] = useState<ITradesPoints>(null);

  useEffect(() => {
    tradeService.getOfficerPoints().then(resp => setTradesPoints(resp));
  }, []);

  return (
    <div className="black-december-dashboard">
      <BlackDecemberPoints {...tradesPoints} />
      <ProgressDaysRemaining />
      <LevelStatus {...tradesPoints} />
      <Divider />
      <BlackDecemberRules />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/welcome/black-december/BlackDecemberDashboard.tsx